import React, { useContext, useState } from "react";
import { useDropzone } from "react-dropzone";
import styled from "styled-components";
import { DatabaseContext } from "../../contexts/DatabaseContext";
import { UserContext } from "../../contexts/UserContext";
import { Button } from "../../components/ui/forms/Button";
import BigButton from "../../components/Photos/BigButton";
import { PatronContext } from "../../contexts/PatronContext";
import { PaneContext } from "../../contexts/PaneContext";
import AddPhotoAlternateIcon from "@material-ui/icons/AddPhotoAlternate";

const PhotoUpload = () => {
  const { patron, uploadPhoto } = useContext(PatronContext);
  const { updatePreviewPane } = useContext(PaneContext);
  const [photoData, setPhotoData] = useState(null);

  const getBase64 = (file, cb) => {
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      cb(reader.result);
    };
    reader.onerror = function (error) {
      console.log("Error: ", error);
    };
  };

  const onDrop = (acceptedFiles) => {
    if (acceptedFiles && acceptedFiles.length > 0) {
      const img = acceptedFiles[0];
      setPhotoData(img);

      getBase64(img, (result) => {
        updatePreviewPane(result);
      });
    }
  };

  const undo = (e) => {
    e.stopPropagation();
    setPhotoData(null);
    updatePreviewPane("");
  };

  const save = async (e) => {
    e.stopPropagation();
    if (!photoData) return;

    try {
      await uploadPhoto(patron.externalID, photoData);
      if (patron) patron.hasPhoto = 1;
      setPhotoData(null);
    } catch (error) {
      console.error("Upload failed", error);
    }
  };

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: "image/jpeg, image/png, image/jpg, image/webp",
    multiple: false,
    noClick: !!photoData,
  });

  return (
    <BigButton
      {...getRootProps()}
      icon={<AddPhotoAlternateIcon style={iconStyles} />}
      colour="success"
      variant="upload"
      isUpload
    >
      <input {...getInputProps()} />
      {photoData ? (
        <Buttons>
          <Button onClick={undo} colour="error" margin="0 1rem 0 0">
            Undo
          </Button>
          <Button colour="success" onClick={save}>
            Save
          </Button>
        </Buttons>
      ) : (
        <div>Click here to select file</div>
      )}
    </BigButton>
  );
};

const iconStyles = {
  fontSize: "110px",
  marginLeft: "80px",
};

const Buttons = styled.div`
  display: flex;
`;

export default PhotoUpload;
